"use client";

import Image from "next/image";

const workshops = [
  {
    image:
      "https://cdn.msu.edu.in/website-images/career-workshop-1.webp",
    caption:"Mr. R. P. Maurya, GM (HR) at Teesta IV Hydroelectric Project at the Pioneering Global Opportunities event",
  },
  {
    image:
      "https://cdn.msu.edu.in/website-images/career-workshop-2.webp",
    caption:"Ms. Debbie Weaver from London Wellness Academy at the Pioneering Global Opportunities event"
  },
  {
    image:
      "https://cdn.msu.edu.in/website-images/photography-workshop-at-best-skill-university-in-india.webp",
    caption:"Tirtha Dasgupta, a renowned photographer at MSU Campus for a photography workshop",
  },
];

export default function Workshops() {
  return (
    <section className="page-container mx-auto py-6 md:py-12">
      {/* Title Section */}
      <div className="w-full text-left mb-2 md:mb-4">
        <h2
          className="text-2xl sm:text-3xl lg:text-4xl mb-2"
          style={{ fontFamily: "saans-bold" }}
        >
          Workshops & Events
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-black leading-relaxed w-full">
          Exposure to industry insights through interactive sessions led by
          professionals
        </p>
      </div>

      {/* Workshop Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
        {workshops.map((workshop, index) => (
          <div
            key={index}
            className="relative group overflow-hidden bg-gray-100 aspect-[4/3]"
          >
            {/* Image */}
            <Image
              src={workshop.image}
              alt={workshop.caption}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
              className="object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />

            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

            {/* Caption */}
            <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
              <p className="text-white text-sm md:text-base leading-relaxed font-medium">
                {workshop.caption}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
